export default __webpack_public_path__ + "static/media/orchid.ebf19cc4.png";